import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

const store = {};
const inflight = {};
const listeners = {};

export const getCached = (key) => store[key];
export const primeCache = (key, data) => { store[key] = data; listeners[key]?.forEach(listener => listener(data)); };
export const patchCachedItem = (key, patch) => {
  if (store[key]) primeCache(key, store[key].map(item => item.id === patch.id ? { ...item, ...patch } : item));
};
export const clearCache = () => { Object.keys(store).forEach((k) => delete store[k]); };

export function fetchFresh(key) {
  if (!inflight[key]) {
    inflight[key] = api.get(`/${key}`)
      .then((r) => { primeCache(key, r.data); return r.data; })
      .finally(() => { delete inflight[key]; });
  }
  return inflight[key];
}

export function useCachedList(key) {
  const [data, setData] = useState(() => getCached(key));
  const refresh = useCallback(async () => {
    const d = await fetchFresh(key);
    setData(d);
    return d;
  }, [key]);
  useEffect(() => {
    (listeners[key] ||= new Set()).add(setData);
    refresh().catch((e) => { if (!getCached(key)) toast.error(apiError(e)); });
    return () => listeners[key].delete(setData);
  }, [refresh, key]);
  return [data, refresh];
}
